module.exports = __webpack_public_path__ + "static/img/主图.3e577e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/match_result/figure/结果页/爱生活/曹晟康/主图.png
// module id = mRaV
// module chunks = 1